import { render, staticRenderFns } from "./ChangeWinners.vue?vue&type=template&id=14c19d09"
import script from "./ChangeWinners.vue?vue&type=script&lang=js"
export * from "./ChangeWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports